import { isEqual } from "lodash";
import { createDirtyChecker } from "../../../gvc/testNewForm/createDirtyChecker";
import {
  inputToContainer,
  inputToJob,
  inputToLoadBalancer,
  inputToOptions,
  inputToRolloutOptions,
} from "./inputToWorkload";
import { inputToSidecar } from "../../../../mst/stores/cpln.jwt.client.draft";

export function getDirtyChecker(id: string, selfLink: string) {
  return createDirtyChecker(id, (x) => x, (i, v) => {
    const dirty: Record<string, boolean> = {};

    if (i.description !== v.description) dirty.description = true;

    // defaultOptions: gated by override/alreadySet toggle
    const iActive = i.defaultOptions.override || i.defaultOptions.alreadySet;
    const vActive = v.defaultOptions.override || v.defaultOptions.alreadySet;
    if (iActive !== vActive) {
      dirty.defaultOptions = true;
    } else if (vActive) {
      if (!isEqual(inputToOptions(i.defaultOptions, i.type), inputToOptions(v.defaultOptions, i.type))) {
        dirty.defaultOptions = true;
      }
    }

    // localOptions: per-item tracking by id
    for (const lo of i.localOptions) {
      if (!v.localOptions.find((item: any) => item.id === lo.id)) {
        dirty[`localOptions.${lo.id}.id`] = true; // removed
      }
    }
    for (let index = 0; index < v.localOptions.length; index++) {
      const lo = v.localOptions[index];
      const _lo = i.localOptions.find((item: any) => item.id === lo.id);
      if (!_lo) {
        dirty[`localOptions.${index}.id`] = true; // new
        continue;
      }
      if (lo.location !== _lo.location) {
        dirty[`localOptions.${index}.location`] = true;
      }
      if (!isEqual(inputToOptions(lo, i.type), inputToOptions(_lo, i.type))) {
        dirty[`localOptions.${index}.id`] = true;
      }
    }

    // containers: per-item tracking by id
    for (const c of i.containers) {
      if (!v.containers.find((item: any) => item.id === c.id)) {
        dirty[`containers.${c.id}.id`] = true; // removed
      }
    }
    for (let index = 0; index < v.containers.length; index++) {
      const c = v.containers[index];
      const _c = i.containers.find((item: any) => item.id === c.id);
      if (!_c) {
        dirty[`containers.${index}.id`] = true; // new
        continue;
      }
      if (!isEqual(inputToContainer(i, c), inputToContainer(i, _c))) {
        dirty[`containers.${index}.id`] = true;
      }
    }

    if (i.identity.value.link !== v.identity.value.link) dirty.identity = true;
    if (!isEqual(inputToJob(i.job), inputToJob(v.job))) dirty.job = true;
    if (
      !isEqual(i.firewallConfig.external.inbound, v.firewallConfig.external.inbound) ||
      !isEqual(i.firewallConfig.external.httpInboundHeaderFilter, v.firewallConfig.external.httpInboundHeaderFilter)
    ) {
      dirty["firewallConfig.external.inbound"] = true;
    }
    if (!isEqual(i.firewallConfig.external.outbound, v.firewallConfig.external.outbound)) {
      dirty["firewallConfig.external.outbound"] = true;
    }
    if (!isEqual(i.firewallConfig.internal, v.firewallConfig.internal)) {
      dirty["firewallConfig.internal"] = true;
    }
    if (!isEqual(inputToLoadBalancer(i.loadBalancer, i.type), inputToLoadBalancer(v.loadBalancer, i.type))) {
      dirty.loadBalancer = true;
    }
    if (i.supportDynamicTags !== v.supportDynamicTags) dirty.supportDynamicTags = true;
    if (i.extras !== v.extras) dirty.extras = true;
    if (!isEqual(i.securityOptions, v.securityOptions)) dirty.securityOptions = true;
    if (!isEqual(inputToRolloutOptions(i.rolloutOptions, i.type), inputToRolloutOptions(v.rolloutOptions, i.type))) {
      dirty.rolloutOptions = true;
    }
    if (!isEqual(i.requestRetryPolicy, v.requestRetryPolicy)) dirty.requestRetryPolicy = true;
    if (!isEqual(inputToSidecar(i.sidecar), inputToSidecar(v.sidecar))) dirty.sidecar = true;
    if (!isEqual(i.tags, v.tags)) dirty.tags = true;

    return dirty;
  });
}
